import {TemplatesApiClient} from "./TemplatesApiClient";
import {FetchApiClient} from "./FetchTemplatesApiClient";
import {StubApiClient} from "./MockTemplatesApiCLient";

export default class ApiClientFactory {

    private static instance: TemplatesApiClient;

    static getTemplatesApiClient(): TemplatesApiClient {
        if (!this.instance) {
            const isDev = process.env.REACT_APP_USE_MOCK_AUTH === 'true';
            this.instance = isDev ? new StubApiClient() : new FetchApiClient();
        }
        return this.instance;
    }
}
